import React from "react";
import Button from "react-bootstrap/Button";
import { Table } from "react-bootstrap";
import { EFILING_PATH } from "../../resources/constants/paths";
import { Label } from "./components/common";
import { CONTINUE_BUTTON_LABEL, EFILING_QUESTION_TEXT_1, EFILING_QUESTION_TEXT_2, EFILING_QUESTION_TEXT_3, EFILING_QUESTION_TEXT_4, EFILING_QUESTION_TEXT_5, EFILING_QUESTION_TEXT_6, EFILING_QUESTION_CHECKBOX_TITLE, EFILING_QUESTION_CHECKBOX_LABEL } from "../../resources/constants/ui";



class EFilingQuestion extends React.Component {
	constructor(props) {
		super(props);
		this.state = {mandatorySelection: false};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	state = {};
	handleChange = e => {
		if(e.target.checked) {
			this.setState({ mandatorySelection: e.target.checked });
		} else {
			this.setState({ [e.target.name]: e.target.value });
		}
	};
	handleSubmit = e => {
		e.preventDefault();
	};
	yesClick = e => {
		e.preventDefault();
		this.props.history.push(EFILING_PATH);
	};
	render() {
		return (
			<div id="EfilingQuestion" key="EfilingQuestion">
				<form id="mainForm" key="mainForm" onSubmit={this.handleSubmit}>
					<Label text={EFILING_QUESTION_TEXT_1} />
					<br />
					<br />
					<Label text={EFILING_QUESTION_TEXT_2} />
					<br />
					<br />
					<Label text={EFILING_QUESTION_TEXT_3} />
					<br />
					<br />
					<Label text={EFILING_QUESTION_TEXT_4} />
					<br />
					<br />
					<Label text={EFILING_QUESTION_TEXT_5} />
					<br />
					<br />
					<Label text={EFILING_QUESTION_TEXT_6} />
					<br />
					<br />
					<div  className="efiling-question-box">
					<Table>
						<tbody>
							<tr><td>
							<Label text={<strong>{EFILING_QUESTION_CHECKBOX_TITLE}</strong>} />
							</td></tr>
							<tr><td>
								<label>
									<input
										type="checkbox"
										checked={this.state.mandatorySelection}
										onChange={this.handleChange}
									/>
								</label>
								<Label text={EFILING_QUESTION_CHECKBOX_LABEL}/>
							</td></tr>
						</tbody>
					</Table>
					</div>
					<br />
					<div className="center">
						<Button
							className="stb-button right-margin"
							onClick={this.yesClick}
							disabled={this.state.mandatorySelection !== true}
						>
							{CONTINUE_BUTTON_LABEL}
						</Button>
					</div>
					<br />
				</form>
			</div>
		);
	}
}

export default EFilingQuestion;
